<template>
  <div style="min-height: 750px;">
    <b-card no-body :class="[d_fullScreen ? 'full-screen-mode' : 'normal-mode']">
      <b-row :style="d_fullScreen ? 'position: fixed; top: 0; left: 0; width: 100%; height: 50px; z-index: 1001; background-color: white; border-bottom: solid 1px #a5aaad; box-shadow: 1px 1px 1px 0px; margin: 0px;' : ''">
        <b-col sm="12" lg="11">
            {{ StoreLangTranslation.data['wdc_campaign_list'][StoreLang]  }}
        </b-col>
        <b-col sm="12" lg="1">
          <b-button class="pull-right" size="lg" variant="white" @click="d_fullScreen ? d_fullScreen = false : d_fullScreen = true">
            <i class="fa fa-desktop"></i>
          </b-button>
        </b-col>
      </b-row>  
      <b-row :style="d_fullScreen ? 'margin-top: 50px;' : 'margin: 0px;'">
        <b-col sm="12" lg="12">
          <wdc-campaign-manage></wdc-campaign-manage>
        </b-col>
      </b-row>
    </b-card>  
  </div>
</template>

<script>

import { ClsUser } from '@/wam/modules/user';
import { ClsWdm } from '@/wam/modules/wdm';
import { ClsRoute } from '@/wam/modules/route';
import store from '@/store';
import { ServiceFunctions } from '@/wam/modules/service';
import {
  default as WdcCampaignManage
} from '@/wam/components/wdc/WdcCampaignManage';
import { mapGetters } from 'vuex';
export default {
  name: 'wdc_campaign_management',
  computed: mapGetters({
    StoreDevice: 'StoreDevice',
    StoreLang: 'StoreLang',
    StoreLangList: 'StoreLangList',
    StoreLangTranslation: 'StoreLangTranslation',
    StoreFrontendSettings: 'StoreFrontendSettings',
  }),
  components: {
    WdcCampaignManage,
  },
  props: {
  },
  data () {
    return {
      d_fullScreen: true,
      d_user: '',
      d_hoverIndex: '',
      d_searchText: '',
      d_frontendClientID: '',
      d_frontendList: [],
      d_usrShpBundleList: [],
      d_usrShpBundWdm: '',
      ClsUser: ClsUser,
    };
  },
  created: function () {
    ClsWdm.getLayerWdm('usr_shp_bund').then(resp_wdm_data => { this.d_usrShpBundWdm = resp_wdm_data; });
    this.d_user = JSON.parse(localStorage.getItem('user'));

    let auth_eligible = false;
    let user_perm_eligibleGeneral = false;
    if (this.$route.meta && this.$route.meta.permission && this.$route.meta.permission.length > 0) {
      auth_eligible = ClsUser.f_checkUserAuth(this.$route.meta.permission, 'without_id');
      if (auth_eligible) {
        user_perm_eligibleGeneral = ClsUser.f_checkUserAuth(['admin', 'wdc_admin']);
      }
    }
    if (this.d_user && this.d_user.username && auth_eligible && user_perm_eligibleGeneral) {
      // this.f_userShopBundleList();
    } else {
      this.$router.push({ path: this.StoreLangTranslation.data['page_404_path'][this.StoreLang], query: {} });
    }
  },
  beforeMount () {},
  mounted: function () {
    // console.log(this.StoreFrontendSettings);
    // console.log(this.d_usrShpBundWdm);
  },
  methods: {
  },
  watch: {
  }
};

</script>

